module.exports = __webpack_public_path__ + "fonts/dFa5ZfeM_74wlPZtksIFYoEf6HOpW3pwfa0.woff2";